import { emptyPhenotypeResponse } from 'FESView/store/consts';
import { logger, ELogEnvironment } from 'Common/utils/logger/logger';
export const handlePhenotypeRequestError = (err) => {
    logger.error(err.message, ELogEnvironment.All);
    return emptyPhenotypeResponse;
};
